export default "__VITE_ASSET__BJpirK1n__"